// DayGrid.jsx - Shared day grid layer for all category rows
import React from 'react';
import { Box, alpha, useTheme } from '@mui/material';

const DayGrid = ({ visibleDayIndices, getDateForDayIndex, dayWidth, totalHeight, showBaseDateIndicator = true }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: totalHeight,
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      {visibleDayIndices.map((dayIndex) => {
        const isBaseDateDay = dayIndex === 0;
        const position = visibleDayIndices.indexOf(dayIndex);

        return (
          <Box
            key={`day-${dayIndex}`}
            sx={{
              position: 'absolute',
              left: position * dayWidth,
              top: 0,
              width: dayWidth,
              height: '100%',
              borderRight: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
              bgcolor: isBaseDateDay && showBaseDateIndicator
                ? alpha(theme.palette.primary.main, 0.1)
                : 'transparent',
            }}
          >
            {/* Base date indicator line */}
            {isBaseDateDay && showBaseDateIndicator && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: '50%',
                  width: '2px',
                  height: '100%',
                  bgcolor: 'primary.main',
                  transform: 'translateX(-50%)',
                  zIndex: 10,
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default DayGrid;
